import styled from "styled-components";

export const MainWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  min-height: 100vh;
  color: #fff;

  .dropdown-item {
    color: #333 !important;
  }

  .bgdark {
    background-color: #007bc6;
    margin-left: -15px;

    a {
      background-color: #05367f;
      margin-bottom: 1px;
      color: #fff;
    }

    hr {
      border-top: 1px solid #3b95f2;
      margin: 10px 0px;
    }
  }

  .btn-primary {
    background-color: #05367f;
    border-color: #05367f;
    
    &:hover {
      background-color: #04295a;
      border-color: #04295a;
    }
    
    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(5, 54, 127, 0.25);
    }
  }

  .card {
    margin: 15px 0px;
    border: none;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    
    .card-header {
      border-bottom: 1px solid rgba(0, 0, 0, 0.125);
      font-weight: 600;
    }
  }

  .badge {
    font-size: 0.875em;
    padding: 0.375rem 0.75rem;
  }

  .table {
    th {
      border-top: none;
      font-weight: 600;
      color: #495057;
      font-size: 0.875rem;
    }
    
    td {
      vertical-align: middle;
      font-size: 0.875rem;
    }
  }

  .bg-success {
    background-color: #28a745 !important;
  }

  .bg-warning {
    background-color: #ffc107 !important;
  }

  .text-success {
    color: #28a745 !important;
  }

  .text-warning {
    color: #ffc107 !important;
  }

  .badge-success {
    background-color: #28a745;
  }

  .badge-warning {
    background-color: #ffc107;
    color: #212529;
  }
`;

export const MainContent = styled.div`
  background-color: #fff;
  padding: 15px;
  display: block;
  margin: 10px 0px;
  color: #333;

  .pull-right {
    position: relative;
    float: right;
  }
`;